module.exports = __webpack_public_path__ + "img/icn_en.19f232d2.svg";